export enum RuleType {
  PROPERTY_EXCLUSION = "PROPERTY_EXCLUSION"
}
